import React from 'react';
import { ProfileWithUser } from '../types';
import './MatchModal.css';

interface MatchModalProps {
  isVisible: boolean;
  matchedUser: ProfileWithUser | null;
  onSendMessage: () => void;
  onKeepSwiping: () => void;
}

export const MatchModal: React.FC<MatchModalProps> = ({
  isVisible,
  matchedUser,
  onSendMessage,
  onKeepSwiping,
}) => {
  if (!isVisible || !matchedUser) {
    return null;
  }

  const mainPhoto = matchedUser.photos.sort((a, b) => a.order - b.order)[0];

  return (
    <div className="match-modal-overlay" onClick={onKeepSwiping}>
      <div className="match-modal" onClick={(e) => e.stopPropagation()}>
        <div className="match-modal-content">
          <h1 className="match-title">It's a Match! 🎉</h1>
          
          <div className="match-profile">
            <div 
              className="match-photo"
              style={{
                backgroundImage: mainPhoto ? `url(${mainPhoto.url})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              }}
            >
              {!mainPhoto && (
                <div className="match-photo-placeholder">
                  <span>{matchedUser.firstName[0]}</span>
                </div>
              )}
            </div>
            
            <h2 className="match-name">{matchedUser.firstName}</h2>
            <p className="match-info">
              {matchedUser.department} • Year {matchedUser.year}
            </p>
          </div>

          <div className="match-actions">
            <button className="btn btn-primary" onClick={onSendMessage}>
              Send Message
            </button>
            <button className="btn btn-secondary" onClick={onKeepSwiping}>
              Keep Swiping
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
